import React from 'react';
import { WIPDepartment, IWIPTask, WIP_COLUMNS } from '@/types/psi';
import WIPKanbanColumn from './WIPKanbanColumn';

interface WIPKanbanBoardProps {
  department: WIPDepartment;
  tasks: IWIPTask[];
  onTaskClick?: (task: IWIPTask) => void;
  language?: 'en' | 'zh';
}

const WIPKanbanBoard: React.FC<WIPKanbanBoardProps> = ({
  department,
  tasks,
  onTaskClick,
  language = 'en',
}) => {
  const columns = WIP_COLUMNS[department];

  // Group tasks by column
  const tasksByColumn = columns.reduce((acc, column) => {
    acc[column.id] = tasks.filter((task) => task.column === column.id);
    return acc;
  }, {} as Record<string, IWIPTask[]>);

  return (
    <div className="flex gap-4 overflow-x-auto pb-4">
      {columns.map((column) => (
        <WIPKanbanColumn
          key={column.id}
          column={column}
          tasks={tasksByColumn[column.id] || []}
          onTaskClick={onTaskClick}
          language={language}
        />
      ))}
    </div>
  );
};

export default WIPKanbanBoard;
